var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTailwindIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.60005C6.79987 6.40017 8.80013 4.80005 12 4.80005C16.8 4.80005 17.4 8.40005 19.8 9.00005C21.4001 9.40017 22.8 8.80017 24 7.20005C23.2001 10.3999 21.1999 12 18 12C13.2 12 12.6 8.40005 10.2 7.80005C8.59988 7.39992 7.2 7.99992 6 9.60005ZM0 16.8C0.799875 13.6002 2.80013 12 6 12C10.8 12 11.4 15.6 13.8 16.2C15.4001 16.6002 16.8 16.0002 18 14.4C17.2001 17.5999 15.1999 19.2 12 19.2C7.2 19.2 6.6 15.6 4.2 15C2.59987 14.5999 1.2 15.1999 0 16.8Z",
    fill: "url(#paint0_linear_3232_9720)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3232_9720",
    x1: 5.96389e-7,
    y1: -7.99983,
    x2: 24,
    y2: 31.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2383AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DD7B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindIcon);
export default __webpack_public_path__ + "static/media/tailwind-icon.aefac521109cce5e4ef3f3ce668b4c5d.svg";
export { ForwardRef as ReactComponent };